import { useState, useMemo } from 'react';
import LoginInputContext from './LoginInputContext';

const LoginInputProvider = ({ children }) => {
    const [userName, setUserName] = useState('');

    const value = useMemo(() => ({
        userName,
        setUserName,
    }), [userName]);

    return (
        <LoginInputContext.Provider value={value}>
            {children}
        </LoginInputContext.Provider>
    );
};

export default LoginInputProvider;
